/**
 * TagIcon — sanitized from `assets/newSvg/tag.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TagIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M10.5374,2.16431 C11.3558,2.08990077 12.1657645,2.35463284 12.7807293,2.89096713 L12.9303,3.03067 L20.7532,10.8536 C21.877936,11.97824 21.9229254,13.7738048 20.8881683,14.9522073 L20.7532,15.0962 L15.0963,20.7531 C13.97166,21.87774 12.1760952,21.9227256 10.9976927,20.8880568 L10.8537,20.7531 L3.03079,12.9302 C2.44965769,12.3490308 2.13450787,11.5573148 2.15285602,10.7415376 L2.16443,10.5372 L2.63584,5.35179 C2.76148708,3.96962417 3.81619042,2.86257507 5.17324036,2.65732594 L5.35191,2.63572 L10.5374,2.16431 Z M8.02428,8.02516 C7.24323,8.80621 7.24323,10.0725 8.02428,10.8536 C8.80533,11.6346 10.0717,11.6346 10.8527,10.8536 C11.6338,10.0725 11.6338,8.80621 10.8527,8.02516 C10.0717,7.24411 8.80533,7.24411 8.02428,8.02516 Z"
        fill={color}
      />
    </Svg>
  );
}

export default TagIcon;
